import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronLeft, ChevronRight, CalendarDays } from 'lucide-react';
import { Button } from '@/shared/components/Button';
import { Input } from '@/shared/components/Input';
function addDays(iso, n) {
    const d = new Date(iso + 'T00:00:00');
    d.setDate(d.getDate() + n);
    return d.toISOString().slice(0, 10);
}
function hoy() {
    return new Date().toISOString().slice(0, 10);
}
export function DateNav({ fecha, onChange }) {
    const d = new Date(fecha + 'T00:00:00');
    const etiqueta = d.toLocaleDateString('es-AR', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
    });
    return (_jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [_jsx(Button, { variant: "secondary", size: "sm", onClick: () => onChange(addDays(fecha, -1)), "aria-label": "D\u00EDa anterior", children: _jsx(ChevronLeft, { className: "h-4 w-4" }) }), _jsxs("div", { className: "flex h-9 min-w-[220px] items-center gap-2 rounded-md border border-border bg-surface px-3 text-sm", children: [_jsx(CalendarDays, { className: "h-4 w-4 text-text-tertiary" }), _jsx("span", { className: "capitalize", children: etiqueta })] }), _jsx(Button, { variant: "secondary", size: "sm", onClick: () => onChange(addDays(fecha, 1)), "aria-label": "D\u00EDa siguiente", children: _jsx(ChevronRight, { className: "h-4 w-4" }) }), _jsx(Button, { variant: "ghost", size: "sm", onClick: () => onChange(hoy()), children: "Hoy" }), _jsx(Input, { type: "date", value: fecha, onChange: (e) => e.target.value && onChange(e.target.value), className: "w-40" })] }));
}
